import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { homeRoutes } from './Home/routes';
import { featureTogglesRoutes } from './FeatureToggles/routes';
import { progressiveDeliveryRoutes } from './ProgressiveDelivery/routes';
import { miscRoutes } from './Misc/routes';
import { profileRoute } from './Profile/routes';

const AppRoutes = () => {
  const { search } = useLocation();

  return (
    <Routes>
      <Route path="/" element={<Navigate to={`home${search}`} />} />
      {homeRoutes}
      {featureTogglesRoutes}
      {progressiveDeliveryRoutes}
      {profileRoute}
      {miscRoutes}
      <Route path="*" element={<Navigate to="/404" />} />
    </Routes>
  );
};

export default AppRoutes;
